module.exports = __webpack_public_path__ + "components/panel/ski-bro/static/euro-817cec876ec5a272cf26d8393cf025fc.jpg";